<template>
  <div class="form-col discount-rule-config">
    <div class="form-item">
      <label class="form-label">
        <span class="label-text">优惠规则配置：</span>
        <span class="label-tip">🏷️</span>
      </label>

      <!-- 启用开关 -->
      <div class="toggle-row">
        <span class="toggle-label">启用优惠计算</span>
        <label class="toggle-switch">
          <input type="checkbox" :checked="localRules.enabled" @change="toggleEnabled">
          <span class="toggle-slider"></span>
        </label>
      </div>

      <div v-if="localRules.enabled" class="rules-body">
        <!-- 满减规则 -->
        <div class="rule-section">
          <h4 class="rule-title">满减规则</h4>
          <div v-for="(t, i) in localRules.thresholds" :key="'t-'+i" class="threshold-row">
            <span class="rule-label">满</span>
            <input type="number" v-model.number="t.threshold" min="0" placeholder="门槛" class="form-input rule-input" @input="emitChange">
            <span class="rule-label">减</span>
            <input type="number" v-model.number="t.discount" min="0" placeholder="减免" class="form-input rule-input" @input="emitChange">
            <button @click="removeThreshold(i)" class="btn btn-delete-small">×</button>
          </div>
          <button @click="addThreshold" class="btn btn-add-small">+ 添加满减档位</button>
        </div>

        <!-- 优惠券 -->
        <div class="rule-section">
          <h4 class="rule-title">优惠券</h4>
          <div v-for="(c, i) in localRules.coupons" :key="'c-'+i" class="coupon-card">
            <div class="coupon-row">
              <input type="text" v-model="c.name" placeholder="券名称" class="form-input" @input="emitChange">
              <input type="number" v-model.number="c.amount" min="0" placeholder="面额" class="form-input" @input="emitChange">
              <input type="number" v-model.number="c.threshold" min="0" placeholder="使用门槛(选填)" class="form-input" @input="emitChange">
              <select v-model="c.applicablePerson" class="form-input" @change="emitChange">
                <option value="">全场通用</option>
                <option v-for="p in personList" :key="p.name" :value="p.name">{{ p.name }}专用</option>
              </select>
              <button @click="removeCoupon(i)" class="btn btn-delete-small">×</button>
            </div>
          </div>
          <button @click="addCoupon" class="btn btn-add-small">+ 添加优惠券</button>
        </div>

        <!-- 分摊策略 -->
        <div class="rule-section">
          <h4 class="rule-title">分摊策略</h4>
          <div class="strategy-group">
            <label v-for="opt in strategyOptions" :key="opt.value" class="strategy-option" :class="{ active: localRules.strategy === opt.value }">
              <input type="radio" :value="opt.value" v-model="localRules.strategy" @change="emitChange">
              <span class="strategy-label">{{ opt.label }}</span>
            </label>
          </div>
          <div v-if="localRules.strategy === 'organizerFirst'" class="organizer-pick">
            <label class="strategy-label">发起人：</label>
            <select v-model="localRules.organizer" class="form-input" @change="emitChange">
              <option value="">请选择发起人</option>
              <option v-for="p in personList" :key="p.name" :value="p.name">{{ p.name }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DiscountRuleConfig',
  props: {
    modelValue: {
      type: Object,
      default: () => ({
        enabled: false,
        thresholds: [{ threshold: 0, discount: 0 }],
        coupons: [{ name: '', amount: 0, threshold: 0, applicablePerson: '' }],
        strategy: 'proportional',
        organizer: ''
      })
    },
    personList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      localRules: JSON.parse(JSON.stringify(this.modelValue))
    }
  },
  watch: {
    modelValue: {
      handler(newVal) {
        const newValStr = JSON.stringify(newVal);
        const localStr = JSON.stringify(this.localRules);
        if (newValStr !== localStr) {
          this.localRules = JSON.parse(newValStr);
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    strategyOptions() {
      return [
        { value: 'proportional', label: '按金额比例分摊' },
        { value: 'perPerson', label: '人均分摊' },
        { value: 'organizerFirst', label: '发起人优先' }
      ]
    }
  },
  methods: {
    emitChange() {
      this.$emit('update:modelValue', JSON.parse(JSON.stringify(this.localRules)))
    },
    toggleEnabled(e) {
      this.localRules.enabled = e.target.checked
      this.emitChange()
    },
    addThreshold() {
      this.localRules.thresholds.push({ threshold: 0, discount: 0 })
      this.emitChange()
    },
    removeThreshold(index) {
      if (this.localRules.thresholds.length > 1) {
        this.localRules.thresholds.splice(index, 1)
      }
      this.emitChange()
    },
    addCoupon() {
      this.localRules.coupons.push({ name: '', amount: 0, threshold: 0, applicablePerson: '' })
      this.emitChange()
    },
    removeCoupon(index) {
      this.localRules.coupons.splice(index, 1)
      this.emitChange()
    }
  }
}
</script>

<style scoped>
.discount-rule-config {
  margin-top: 0;
}

.toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  margin-bottom: 12px;
}

.toggle-label {
  font-weight: 600;
  color: #4a5568;
  font-size: 14px;
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 48px;
  height: 26px;
  cursor: pointer;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: #cbd5e0;
  border-radius: 26px;
  transition: 0.3s;
}

.toggle-slider::before {
  content: '';
  position: absolute;
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background: white;
  border-radius: 50%;
  transition: 0.3s;
}

.toggle-switch input:checked + .toggle-slider {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.toggle-switch input:checked + .toggle-slider::before {
  transform: translateX(22px);
}

.rules-body {
  margin-top: 10px;
}

.rule-section {
  margin-bottom: 16px;
}

.rule-title {
  font-size: 13px;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 8px;
  padding-left: 4px;
  border-left: 3px solid #667eea;
}

.threshold-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}

.rule-label {
  font-size: 12px;
  color: #718096;
  white-space: nowrap;
}

.rule-input {
  flex: 1;
  min-width: 60px;
}

.coupon-card {
  background: #f8fafc;
  border-radius: 6px;
  padding: 8px;
  margin-bottom: 6px;
  border-left: 3px solid #48bb78;
}

.coupon-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
}

.coupon-row .form-input {
  flex: 1;
  min-width: 80px;
}

.strategy-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.strategy-option {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 6px 12px;
  border: 2px solid #e2e8f0;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  color: #4a5568;
  transition: all 0.3s;
}

.strategy-option.active {
  border-color: #667eea;
  background: rgba(102, 126, 234, 0.05);
  color: #667eea;
}

.strategy-option input[type="radio"] {
  accent-color: #667eea;
}

.organizer-pick {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.btn-add-small {
  background: linear-gradient(135deg, #48bb78 0%, #38a169 100%);
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 4px 12px;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s;
}

.btn-add-small:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(72, 187, 120, 0.3);
}

.btn-delete-small {
  background: #f56565;
  color: #fff;
  border: none;
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 14px;
  cursor: pointer;
  line-height: 1.2;
  transition: all 0.3s;
}

.btn-delete-small:hover {
  background: #e53e3e;
}

@media (max-width: 750px) {
  .threshold-row {
    flex-wrap: wrap;
    gap: 4px;
  }

  .coupon-row {
    flex-direction: column;
  }

  .coupon-row .form-input {
    width: 100%;
  }

  .strategy-group {
    flex-direction: column;
  }
}
</style>
